import { render } from "./SlaWidget.vue?vue&type=template&id=492f3ac5&scoped=true"
import script from "./SlaWidget.vue?vue&type=script&lang=js"
export * from "./SlaWidget.vue?vue&type=script&lang=js"

import "./SlaWidget.vue?vue&type=style&index=0&id=492f3ac5&scoped=true&lang=css"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-492f3ac5"]])

export default __exports__